<template>

    <div id="site-file-modal" class="modal" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Attached Files</h5>
                    <button aria-label="Close" class="close" type="button" v-on:click="close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">

                    <h6>Line Item</h6>

                    <dl>
                        <dt>Date</dt>
                        <dd>{{ lineData.document_order_date_human }}</dd>

                        <dt>Site</dt>
                        <dd>{{ lineData.site }}</dd>

                        <dt>Document</dt>
                        <dd>{{ lineData.document_number }}</dd>
                    </dl>

                    <h6>Files</h6>

                    <ul>
                        <li v-for="file in files">
                            <a :href="`/site/file/${file.id}`" target="_blank">{{ file.name }}</a> ({{ file.type }})
                        </li>
                    </ul>

                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: 'SiteFileModalComponent',
    props: {
        lineData: {
            type: Object
        },
        files: {
            type: Array
        },
        isOpen: {
            type: Boolean,
            default: false
        }
    },

    mounted () {
        const fileModal = this
        const fileModalEl = $('#site-file-modal')

        fileModalEl.on('show.bs.modal', function () {
            fileModal.$emit('open:modal')
        })

        fileModalEl.on('hide.bs.modal', function () {
            fileModal.$emit('close:modal')
        })
    },

    watch: {

        isOpen (shouldOpen, isOpen) {
            if (shouldOpen && !isOpen) {
                $('#site-file-modal').modal('show')
            }

            else if (!shouldOpen && isOpen) {
                $('#site-file-modal').modal('hide')
            }
        }

    },

    methods: {

        open () {
            this.$emit('open:modal')
        },

        close () {
            this.$emit('close:modal')
        }

    }
}
</script>
